import {formatDate, formatCurrency} from '../../../utils';
import {formatPeriod} from '../utils/duration';
import CurrencyTotals from './CurrencyTotals';

const CompanyDetail = ({company, projects, onEdit, onDelete}) => {
    const companyProjects = projects.filter(p => p.companyId === company.id);
    const incomeStats = company.incomeStats ?? [];
    const grossTotals = Object.fromEntries(incomeStats.map(s => [s.currencyCode, s.gross]));
    const netTotals = Object.fromEntries(incomeStats.map(s => [s.currencyCode, s.net]));
    const currencies = incomeStats.map(s => s.currencyCode).sort();
    const activeCount = companyProjects.filter(p => !p.endDate).length;
    const period = formatPeriod(company.startDate, company.endDate);

    return (
        <div className="entity-detail">
            <div className="entity-detail__header">
                <div className="entity-detail__heading">
                    <h3 className="entity-detail__title">{company.name}</h3>
                </div>
                {company.website && (
                    <a className="entity-detail__link"
                       href={company.website.startsWith('http') ? company.website : `https://${company.website}`}
                       target="_blank" rel="noopener noreferrer">
                        {company.website}
                    </a>
                )}
                <button className="detail-btn" onClick={onEdit}>Edit</button>
                <button className="detail-btn detail-btn--danger" onClick={onDelete}>Delete</button>
            </div>

            {period && <span className="entity-detail__meta">{period}</span>}

            {company.notes && <p className="entity-detail__notes">{company.notes}</p>}

            <div className="entity-detail__stats">
                <span className="entity-stats-count">
                    {companyProjects.length} projects{activeCount > 0 ? ` · ${activeCount} active` : ''}
                </span>
                {currencies.length > 0 && (
                    <div className="entity-stats-grid">
                        {currencies.map(c => (
                            <div key={c} className="entity-stats-line">
                                <span className="entity-stats-line__currency">{c}</span>
                                <span className={`entity-stats-line__${grossTotals[c] ?? 0 >= 0 ? 'pos' : 'neg'}`}>{formatCurrency(grossTotals[c] ?? 0, c)}</span>
                                <span className="entity-stats-line__dim">gross</span>
                                <span className="entity-stats-line__sep">·</span>
                                <span className={`entity-stats-line__${netTotals[c] ?? 0 >= 0 ? 'pos' : 'neg'}`}>{formatCurrency(netTotals[c] ?? 0, c)}</span>
                                <span className="entity-stats-line__dim">net</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {companyProjects.length > 0 && (
                <div className="entity-detail__section">
                    <h4 className="entity-detail__subtitle">Projects</h4>
                    <div className="project-list">
                        {companyProjects.map(p => {
                            const pStats = p.incomeStats ?? [];
                            const pGross = Object.fromEntries(pStats.map(s => [s.currencyCode, s.gross]));
                            return (
                                <div key={p.id} className="project-row">
                                    <div className="project-row__info">
                                        <span className="project-row__title">{p.title}</span>
                                        <span className="project-row__dates">
                                        {formatDate(p.startDate)} – {p.endDate ? formatDate(p.endDate) : 'ongoing'}
                                    </span>
                                    </div>
                                    <div className="project-row__totals">
                                        <CurrencyTotals totals={pGross} fallback="no income"/>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CompanyDetail;